import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquidate-picker',
	templateUrl:'./JQUIDatePickerPluginCompPage.html',
	styles: [],
	styleUrls:['./JQUIDatePickerPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIDatePickerPluginCompPage
{
	mdContent_1008 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.datepicker.JQUIDatePicker;
\`\`\``;
	mdContent_1009 = `\`\`\`java
JQUIDatePicker()
\`\`\``;
	mdContent_1010 = `\`\`\`java
JQUIDatePicker&lt;?&gt; dp = new JQUIDatePicker&lt;&gt;();
dp.getOptions().setDateFormat("yy-mm-dd");
dp.getOptions().setChangeMonth(true);
dp.getOptions().setChangeYear(true);
dp.getOptions().setNumberOfMonths(2);
\`\`\``;
}
